(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-reviews-section]').forEach((section) => {
    const slider = section.querySelector('[data-reviews-slider]');
    const slides = section.querySelectorAll('.review-item');
    const dots = section.querySelectorAll('[data-review-dots] .dot');

    if (!slider || slides.length === 0) return;

    let currentSlide = 0;

    function goToSlide(index) {
      if (index >= slides.length) {
        currentSlide = 0;
      } else if (index < 0) {
        currentSlide = slides.length - 1;
      } else {
        currentSlide = index;
      }

      slider.style.transform = `translateX(-${currentSlide * 100}%)`;

      dots.forEach((dot, index) => {
        dot.classList.toggle('active', index === currentSlide);
      });
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        goToSlide(Number(dot.dataset.index));
      });
    });

    if (slides.length > 1) {
      setInterval(() => {
        goToSlide(currentSlide + 1);
      }, 5000);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
